import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiService } from '@services/api.service';
import { catchError, map } from 'rxjs/operators';
import { LoggerService } from '@services/logger.service';
import { CustomerModel } from '@/models/tables/customer.model';
import { TableDataApiParams } from '@services/practices.service';
import { TablePaginationRespModel } from '@/models/table-pagination-resp.model';

@Injectable({
  providedIn: 'root',
})
export class CustomersService extends ApiService {
  /**
   * Recupera i dati paginati dei clienti BP dall'API
   * @param params Parametri per paginazione, ordinamento e filtri
   * @returns Observable con la risposta paginata contenente i clienti
   */
  getDataForTable(
    params?: TableDataApiParams,
  ): Observable<TablePaginationRespModel<CustomerModel>> {
    return this.http
      .get<TablePaginationRespModel<CustomerModel>>(this.baseUrl + `/customers/page`, {
        params: { ...params },
      })
      .pipe(
        map((response: any) => {
          LoggerService.log(response, 'getDataForTable Customers');
          return response;
        }),
      );
  }

  /**
   * Recupera un singolo cliente BP tramite ID
   * @param id ID del cliente
   * @returns Observable con il cliente
   */
  getCustomerById(id: number): Observable<CustomerModel> {
    return this.http.get(this.baseUrl + `/customers/${id}`).pipe(
      map((response: any) => {
        LoggerService.log(response, 'getCustomerById');
        return response;
      }),
    );
  }

  /**
   * Salva un nuovo cliente BP o aggiorna uno esistente
   * @param customer Dati del cliente da salvare
   * @returns Observable con la risposta del salvataggio
   */
  saveCustomer(customer: CustomerModel) {
    return this.http.post(this.baseUrl + `/customers/save`, customer).pipe(
      map((response: any) => {
        LoggerService.log(response, 'saveCustomer');
        return response;
      }),
    );
  }

  /**
   * Elimina un cliente BP
   * @param id ID del cliente da eliminare
   * @returns Observable con la risposta della cancellazione
   */
  deleteCustomer(id: number) {
    return this.http.delete(this.baseUrl + `/customers/${id}`).pipe(
      map((response: any) => {
        LoggerService.log(response, 'deleteCustomer');
        return response;
      }),
    );
  }

  /**
   * Cerca utilizzatori (clienti) per autocomplete
   * @param searchQuery Termine di ricerca (minimo 3 caratteri)
   * @returns Observable con la lista di clienti trovati
   */
  searchUtilizzatori(searchQuery: string): Observable<CustomerModel[]> {
    if (!searchQuery || searchQuery.length < 3) {
      return of([]);
    }

    return this.http
      .get<TablePaginationRespModel<CustomerModel>>(this.baseUrl + `/customers/page`, {
        params: {
          page: 1,
          size: 50,
          filter: searchQuery,
        },
      })
      .pipe(
        map((response: any) => {
          LoggerService.log(response, 'searchUtilizzatori');
          return response.content || [];
        }),
        catchError((error) => {
          LoggerService.error('searchUtilizzatori failed', error);
          return of([]);
        }),
      );
  }
}
